import styled from "styled-components"

export const Container = styled.div`
  max-width: 640px;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 110px;
`
